import NextLink from 'next/link';
import PropTypes from 'prop-types';
import { cloneElement } from 'react';

import Icon from 'shopper/components/Icon';
import Link from 'shopper/components/Link';
import Text from 'shopper/components/Text';

const getWrappedComponent = ({
  'aria-label': ariaLabel,
  children,
  icon,
  link,
}) => {
  if (link) {
    return (
      <NextLink href={link} prefetch={false} passHref>
        <Link
          aria-label={ariaLabel}
          className="flex items-center text-ellipsis whitespace-nowrap text-sm text-rd-primary-700 hover:text-rd-primary-500 dark:text-rd-primary-700 dark:hover:text-rd-primary-500"
        >
          {icon
            ? cloneElement(icon, {
                'aria-label': ariaLabel,
                size: 'size3',
                className: 'text-rd-primary-700 dark:text-rd-primary-700',
              })
            : children}
          <Icon
            className="text-rd-neutral-500 dark:text-rd-neutral-500"
            name="arrow-forward"
            size="size3"
          />
        </Link>
      </NextLink>
    );
  }

  if (icon) {
    return cloneElement(icon, {
      'aria-label': ariaLabel,
      size: 'size2',
      className: 'text-rd-primary-700 dark:text-rd-primary-700',
    });
  }

  return (
    <Text className="text-ellipsis whitespace-nowrap text-sm" size="size2">
      {children}
    </Text>
  );
};

const BreadcrumbItem = ({ 'aria-label': ariaLabel, children, link, icon }) => {
  const wrapped = getWrappedComponent({
    children,
    icon,
    link,
    'aria-label': ariaLabel,
  });

  return <li className="inline">{wrapped}</li>;
};

BreadcrumbItem.propTypes = {
  'aria-label': PropTypes.string,
  /**
   * Components to be rendered inside component
   */
  children: PropTypes.node,
  /**
   * Renders an icon as children
   */
  icon: PropTypes.node,
  /**
   * Renders an anchor as children
   */
  link: PropTypes.string,
};

export default BreadcrumbItem;
